import React from 'react';
import styles from './content-slider.module.scss';
import Typography from '@smart-tv/components/typography';
import testIds from '@smart-tv/e2e/shared/variables';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  to?: string;
  showStripeTitle?: boolean;
}

export const ContentSliderHeader: React.FC<Props> = ({
  title,
  showStripeTitle = true,
  className,
  children,
  ...rest
}) => (
  <div className={[styles['header'], className].filter(Boolean).join(' ')} {...rest}>
  
    {showStripeTitle && (
      <Typography 
        className={styles['title']} 
        component="div" variant="h6" 
        textTransform="initial"
        data-testid={testIds.contentSlider.headerTitle}
      >
        {title}
      </Typography>
    )}
    <div className={styles['actions']}>{children}</div>
  </div>
);

export default React.memo(ContentSliderHeader);
